export const KEY_TYPE_LIQPAY = 'liqpay';
export const KEY_TYPE_MONOPAY = 'monopay';

export type KeyType = typeof KEY_TYPE_LIQPAY | typeof KEY_TYPE_MONOPAY;

export const KEY_TYPES: Record<KeyType, string> = {
  [KEY_TYPE_LIQPAY]: 'Liqpay',
  [KEY_TYPE_MONOPAY]: 'Monopay',
};

export const KEY_TYPE_OPTIONS = [
  { id: KEY_TYPE_LIQPAY, name: 'Liqpay' },
  { id: KEY_TYPE_MONOPAY, name: 'Monopay' },
];
